(() => {
  // Site vocabulary supplements the browser dictionary (names and polite endings
  // are otherwise split into individual kana). Keep units short enough for cards.
  const vocabulary = [
    'あげ太くん', 'あげ太', 'あげ子', 'ポテ介', 'ノリ夫', 'めし蔵',
    'キーホルダー', 'クリアファイル', 'タオルハンカチ', 'ヘアクリップ',
    'マグネットシート', 'スライドパズル', 'ステッカー', 'Tシャツ',
    'プライバシー', 'ポリシー', 'メンバーシップ', 'マイページ',
    'お問い合わせ', 'こちらより', 'お気に入り', '組み合わせて',
    'ご了承ください', 'ご確認ください', 'ご連絡ください', 'お楽しみください',
    'いただけます', 'いただきます', 'いただいた', 'いただく', 'いただき',
    'いたします', 'いたしかねます', 'しています', 'されます', 'される',
    'できません', 'できる', 'できます', 'ありません', 'ありませんでした',
    'おりません', 'おります', 'ございます', 'ください', 'しよう',
    'うーじゃー', 'ぱーじゃー', 'ごめんなさい', 'リニューアル', 'オープン',
  ].sort((a, b) => b.length - a.length);
  const escapedVocabulary = vocabulary.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const protectedWords = new RegExp(`(${escapedVocabulary.join('|')})`, 'gu');
  const suffixes = new Set(['の', 'に', 'は', 'を', 'が', 'と', 'や', 'で', 'も', 'へ', 'から', 'まで', 'より', 'だけ', 'など', 'な', 'て', 'た', 'ます', 'です', 'ので', 'ため', 'する', 'し', '後', '前', '中', '時', '様', 'さん', 'くん']);
  const prefixes = new Set(['お', 'ご', '御']);
  const opening = /^[「『（【〈《〔［｛([{]+$/u;
  const closing = /^[、。，．！？!?：:；;・」』）】〉》〕］｝)\]}]+$/u;
  const japanese = /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u;
  const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter('ja', { granularity: 'word' }) : null;

  function splitJapaneseText(text) {
    if (!segmenter || !japanese.test(text)) return [text];
    const tokens = text.split(protectedWords).filter(Boolean).flatMap(part =>
      vocabulary.includes(part) ? [part] : [...segmenter.segment(part)].map(item => item.segment));
    const units = [];
    let prefix = '';
    for (const token of tokens) {
      if (/^\s+$/u.test(token)) {
        if (prefix) { units.push(prefix); prefix = ''; }
        units.push(token);
      } else if (opening.test(token) || prefixes.has(token)) {
        prefix += token;
      } else if (!prefix && units.length && !/^\s+$/u.test(units.at(-1)) && ((suffixes.has(token) && (units.at(-1) + token).length <= 10) || closing.test(token))) {
        units[units.length - 1] += token;
      } else {
        units.push(prefix + token);
        prefix = '';
      }
    }
    if (prefix) units.push(prefix);
    return units;
  }

  if (typeof module !== 'undefined') module.exports = { splitJapaneseText };
  if (typeof document === 'undefined' || !segmenter) return;

  const roots = '#MainContent, .header, .global-menu, .footer';
  const textContainers = 'h1,h2,h3,h4,h5,h6,p,li,dt,dd,th,td,label,button,a,legend,.combination-option__selection';
  const excluded = 'script,style,textarea,input,select,option,pre,code,svg,noscript,[contenteditable],.ageta-text-unit,.create-hero__phrase,.contact-page__keep-together,[data-no-text-wrap]';
  const cache = new Map();

  function wrapText(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded) || !parent.closest(roots) || !parent.closest(textContainers)) return;
    const text = node.textContent;
    if (!japanese.test(text) || text.length > 5000) return;
    let units = cache.get(text);
    if (!units) {
      units = splitJapaneseText(text);
      if (cache.size >= 500) cache.clear();
      cache.set(text, units);
    }
    // Preserve one anonymous text item when the parent uses flex or grid.
    const fragment = document.createElement('span');
    fragment.className = 'ageta-text-flow';
    units.forEach(unit => {
      if (/^\s+$/u.test(unit)) { fragment.append(document.createTextNode(unit)); return; }
      const span = document.createElement('span');
      span.className = 'ageta-text-unit';
      span.textContent = unit;
      fragment.append(span);
    });
    node.replaceWith(fragment);
  }

  function enhance(root) {
    if (root.nodeType === Node.TEXT_NODE) { wrapText(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded) || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(wrapText);
  }

  function init() {
    document.querySelectorAll(roots).forEach(enhance);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') enhance(record.target);
        else record.addedNodes.forEach(enhance);
      }
    });
    // New cart/account content and selection labels keep the same text rules.
    document.querySelectorAll(roots).forEach(root => observer.observe(root, { childList: true, subtree: true, characterData: true }));
    document.addEventListener('shopify:section:load', event => {
      enhance(event.target);
      observer.observe(event.target, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
